import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const coverageBuilderConfigIssue = z.object({
  path: z.string(),
  message: z.string(),
});

export const getCoverageBuilderConfig = unaryRpc({
  name: "getCoverageBuilderConfig",
  input: z.object({ teamId: zExt.objectId() }),
  output: z.discriminatedUnion("status", [
    z.object({
      status: z.literal("ok"),
      config: z.record(z.string(), z.unknown()),
      warnings: z.array(coverageBuilderConfigIssue),
    }),
    z.object({
      status: z.literal("invalid_stored_config"),
      issues: z.array(coverageBuilderConfigIssue),
    }),
  ]),
});

export const uploadCoverageBuilderConfig = unaryRpc({
  name: "uploadCoverageBuilderConfig",
  input: z.object({ teamId: zExt.objectId(), config: z.unknown() }),
  output: z.discriminatedUnion("status", [
    z.object({ status: z.literal("applied") }),
    z.object({
      status: z.literal("invalid"),
      issues: z.array(coverageBuilderConfigIssue),
    }),
  ]),
});
